<!--
/**
* @name: List.vue
* @description: 物料扩展信息管理
* @author: 于海威
* @create: 2020/08/13 10:39:33
* @update: 2020/08/13 10:39:33
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-input placeholder="请输入物料名称" clearable v-model="para.goodsName"></k-input>
      </y-query-item>
      <y-query-item>
        <k-input placeholder="请输入物料编码" clearable v-model="para.goodsCode"></k-input>
      </y-query-item>
      <y-query-item>
        <k-auto-complete
          ref="au"
          :data="brandList"
          v-model="para.goodsBrandCode"
          key-field="brandCode"
          value-field="gbname"
          search-field="gbname"
          layer-width=""
          placeholder="请选择商品品牌"
          @focus="onFocus"
          @toggle="onToggle"
          @input="onInput"
          :empty="empty"
          :text="text"
        >
          <div slot-scope="{ row }" :key="row.brandCode" class="list">
            <span class="name">{{ row.gbname }}</span>
          </div>
        </k-auto-complete>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
      <y-query-item slot="right">
        <k-group>
          <k-group-item>
            <k-input clearable placeholder="请输入物料编码" v-model="goodsCode"></k-input>
          </k-group-item>
          <k-group-item>
            <y-button icon="k-icon-add" @click="onAddMateriel">添加扩展信息</y-button>
          </k-group-item>
        </k-group>
      </y-query-item>
    </y-query>
    <k-table :data="materielList" :height="$root.tableHeightX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
    <k-popup :show.sync="isShowSync" @after-ok="onSaveSync" okText="确认同步" title="选择商品">
      <y-popup-body size="big">
        <div>说明：点击“确认同步”，会将物料扩展信息里面的内容同步给被选择的商品货号，如果商品货号 之前已有相关内容，内容会被覆盖，请谨慎操作。</div>
        <k-table :data="extendSyncList" checkboxKey="goodsCodeSale" :selectedRows.sync="selectedSyncRows" :selectedKeys.sync="goodsCodeList" class="mt-1 mb-2" hasCheckbox :columns="initSyncColumns()">
        </k-table>
      </y-popup-body>
    </k-popup>
  </y-view>
</template>

<script>
import {
  NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_BRAND_LIST,
  NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_PAGE,
  NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_DISABLED,
  NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_ENABLED,
  NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_IS_EXIST,
  NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_IS_EXIST_BY_BASE_DATA,
  NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_SYNC,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_BY_GOODS_CODE,
} from "@/assets/modules/apiList";
const initPara = () => ({
  goodsName: "",
  goodsCode: "",
  goodsBrandCode: "",
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      materielList: [],
      isShowSync: false,
      extendSyncList: [],
      selectedSyncRows: [],
      goodsCodeList: [],
      para: initPara(),
      total: 0,
      isLoading: false,
      isSaving: false,
      goodsCode: "",
      selectedGoodCode: "",
      brandList: [],
      text: "",
      empty: "",
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "物料编码",
          field: "goodsCode",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "物料名称",
          field: "goodsName",
          style: {
            width: 200,
            textAlign: "center",
          },
        },
        {
          name: "品牌",
          field: "goodsBrandName",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "品牌归属地",
          field: "goodsBrandCountryName",
          style: {
            width: 100,
            textAlign: "center",
          },
        },
        {
          name: "状态",
          field: "isEnabled",
          style: {
            width: 60,
            textAlign: "center",
          },
          customRender: (row) => (
            <k-switch
              checked={row.isEnabled}
              readonly
              onClick={() => {
                this.onChangeStatus(row);
              }}
            />
          ),
        },
        {
          name: "操作",
          field: "",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => {
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEdit(row);
                }}
              >
                编辑
              </a>
            );
            const syncButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onSync(row);
                }}
              >
                同步
              </a>
            );
            return (
              <div>
                {editButton}&#12288;{syncButton}
              </div>
            );
          },
        },
      ];
    },
    initSyncColumns() {
      return [
        {
          name: "系列名称",
          field: "",
          style: {
            width: 150,
            textAlign: "center",
          },
          customRender: (row) => {
            const hh = <p class="list">{row.goodsMaterialExtendVO.goodsSeriesName}</p>;
            return <div>{hh}</div>;
          },
        },
        {
          name: "商品名称",
          field: "goodsNameSale",
          style: {
            width: 150,
            textAlign: "center",
          },
        },
        {
          name: "商品货号",
          field: "goodsCodeSale",
          style: {
            width: 100,
            textAlign: "center",
          },
        },
      ];
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getMaterielList();
    },
    onFocus() {},
    onToggle(e) {
      // console.log("toggle", e, this.editPara.goodsCodeSale);
    },
    onInput(text) {},
    onReset() {
      this.para = initPara();
      this.$refs.au.inputText = '';
      this.getMaterielList();
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getMaterielList();
    },
    onSync(row) {
      this.selectedSyncRows = [];
      this.goodsCodeList = [];
      this.selectedGoodCode = row.goodsCode;
      this.getGoodsList(row.goodsCode);
    },
    getGoodsList(goodsCode) {
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_BY_GOODS_CODE,
        para: { goodsCode: goodsCode },
      }).then((res) => {
        this.extendSyncList = res || [];
        this.isShowSync = true;
      });
    },
    onSaveSync() {
      let { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      if (this.goodsCodeList.length === 0) {
        return tip("请选择商品");
      }
      this.isLoading = true;
      this.isSaving = true;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_SYNC,
        para: { goodsCode: this.selectedGoodCode, goodsCodeSaleList: this.goodsCodeList },
      })
        .then((res) => {
          this.isLoading = false;
          this.isSaving = false;
          this.isShowSync = false;
          this.selectedSyncRows = [];
          this.goodsCodeList = [];
          tip("同步成功");
          this.getMaterielList();
        })
        .catch(() => {
          this.isLoading = false;
          this.isSaving = false;
        });
    },
    onEdit(row) {
      // 新开标签
      this.$controller.open({
        name: "materielAdd",
        query: {
          refresh: new Date() - 0,
          code: row.goodsCode,
          id: row.id,
          edit: 1,
        },
        title: "编辑物料信息",
      });
    },
    onAddMateriel() {
      const { tip } = this.$root;
      if (this.goodsCode.replace(/\s*/, "").length < 1) {
        return tip("请先输入物料编码");
      }
      if (this.goodsCode.split(",").length > 1 || this.goodsCode.split("，").length > 1) {
        return tip("只能输入一个物料编码");
      }
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_IS_EXIST_BY_BASE_DATA,
        para: { goodsCode: this.goodsCode },
      }).then((res) => {
        if (!res) {
          return tip("该物料编码的在主数据中是停用状态");
        } else {
          this.$fetch({
            api: NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_IS_EXIST,
            para: { goodsCode: this.goodsCode },
          }).then((response) => {
            if (response) {
              return tip("该物料编码的物料扩展信息已存在");
            } else {
              this.$controller.open({
                name: "materielAdd",
                query: {
                  refresh: new Date() - 0,
                  code: this.goodsCode,
                },
              });
            }
          });
        }
      });
    },
    onChangeStatus(row) {
      let { id, isEnabled } = row;
      this.$dialog({
        title: "提示",
        content: `是否确认${row.isEnabled ? "停用" : "启用"}该物料扩展信息？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: row.isEnabled ? NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_DISABLED : NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_ENABLED,
            para: { id },
          })
            .then(() => {
              this.isLoading = false;
              this.getMaterielList(this.menuId);
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    getMaterielList() {
      let { para } = this;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_PAGE,
        para,
      }).then((res) => {
        this.materielList = res.pageList;
        this.total = res.total;
      });
    },
    getBrandList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_BRAND_LIST,
        para: {},
      }).then((res) => {
        this.brandList = res;
      });
    },
  },
  created() {
    this.getBrandList();
    this.getMaterielList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getMaterielList();
    next();
  },
};
</script>

<style lang="postcss" module="css"></style>
